var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 69,
    viewBox: "0 0 64 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9072 0.757812C27.2097 5.16425 15.1856 9.61146 1.16663 19.0481C1.16663 19.0481 2.04255 50.9359 31.9072 68.3658V0.757812Z",
    fill: "#98C6CF",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9075 0.757812C36.605 5.16425 48.6291 9.61146 62.648 19.0481C62.648 19.0481 61.7723 50.9359 31.9075 68.3658V0.757812Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9074 3.47656C26.2372 7.43691 16.4121 11.2104 3.42163 19.9548C3.42163 19.9548 4.23321 49.504 31.9074 65.6556C59.5819 49.504 60.3932 19.9548 60.3932 19.9548C47.4027 11.2104 37.6214 7.43691 31.9074 3.47656Z",
    fill: "#98C6CF",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5725 47.175C16.7854 53.7662 22.9325 60.4132 31.9072 65.6509C46.8335 56.9395 53.943 44.3324 57.3276 34.5644C36.5177 27.4301 20.5637 39.1015 12.5725 47.175Z",
    fill: "#69ABB9",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3875 27.5904H36.5512V16.6875H27.2632V27.5904H16.4271V36.936H27.2632V47.839H36.5512V36.936H47.3875V27.5904Z",
    fill: "white",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3876 32.4682C39.3165 31.8299 32.2035 33.8804 26.282 36.9364H27.2632V47.8393H36.5513V36.9364H47.3873V32.4682H47.3876Z",
    fill: "#E9F3F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3875 27.5904H36.5512V16.6875H27.2632V27.5904H16.4271V36.936H27.2632V47.839H36.5512V36.936H47.3875V27.5904Z",
    stroke: "#69ABB9",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.c9aa7fc16dccc689744c3e1959f296bd.svg";
export { ForwardRef as ReactComponent };